import type { AssuranceSort, Sort } from "@unbox/api";
import type { FiltersApiValues } from "@/providers/filter-registry";

export const FLAGGED_DEFAULT_SORT: Sort<AssuranceSort> = { column: "publishDate", direction: "desc" };

// Single source of truth for the filter/search/sort params every flagged tab, its
// category badge and the CSV export send to the assurance video endpoint. Category and
// actionTaken stay with each caller because they identify the queue, not the filters.
export const buildFlaggedVideoParams = (apiFilters: FiltersApiValues, search: string) =>
  ({
    sort: FLAGGED_DEFAULT_SORT,
    search,
    riskId: apiFilters.riskId,
    riskTier: apiFilters.riskTier,
    creatorType: apiFilters.creatorType,
    hooks: apiFilters.hooks,
    tactics: apiFilters.tactics,
    sellingPoints: apiFilters.sellingPoints,
    videoStyles: apiFilters.videoStyles,
    videoLanguages: apiFilters.videoLanguages,
    publishDateStart: apiFilters.publishDateStart,
    publishDateEnd: apiFilters.publishDateEnd,
    flaggedDateStart: apiFilters.flaggedDateStart,
    flaggedDateEnd: apiFilters.flaggedDateEnd,
    campaignIds: apiFilters.campaignIds,
    minViews: apiFilters.minViews,
    maxViews: apiFilters.maxViews,
    not: apiFilters.not,
  }) as const;
